import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
    name: "about",
    data() {
        return {}
    },
    created() {
        this.fetchContent()
    },
    computed: {
        ...mapGetters({
            aboutContent: 'home/aboutContent'
        })
    },

    methods: {
        ...mapMutations({}),
        ...mapActions({
            fetchContent: 'home/ABOUT_CONTENT'
        })
    }
}
